import { render, staticRenderFns } from "./public_article.vue?vue&type=template&id=b26a82ec&lang=pug"
import script from "./public_article.vue?vue&type=script&lang=js"
export * from "./public_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports